import { Box, Typography } from '@mui/material';
import { alpha, tokens } from '../../theme/tokens';

export function EmptyState({ title, description, action }) {
  return (
    <Box
      sx={{
        width: '100%',
        py: { xs: 3, sm: 4, md: 5 },
        px: { xs: 2, sm: 2.5, md: 3.5 },
        borderRadius: { xs: 2, sm: 3 },
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: tokens.surface,
        color: tokens.ink,
        boxShadow: `0 16px 40px ${alpha(tokens.shellDeep, 0.22)}`,
        backgroundImage: 'none',
      }}
    >
      {title ? (
        <Typography
          variant="h6"
          sx={{
            mb: 1,
            fontFamily: '"Fraunces", Georgia, serif',
            fontWeight: 650,
            letterSpacing: '-0.02em',
            color: tokens.ink,
            fontSize: { xs: '1.15rem', sm: '1.3rem' },
          }}
        >
          {title}
        </Typography>
      ) : null}
      {description ? (
        <Typography
          sx={{
            mb: action ? 2.5 : 0,
            maxWidth: 520,
            lineHeight: 1.65,
            color: tokens.inkMuted,
            fontSize: { xs: '1rem', sm: '1.05rem' },
          }}
        >
          {description}
        </Typography>
      ) : null}
      {action}
    </Box>
  );
}
